import { isEmpty } from "lodash";
import { EOL } from "os";
import { setFormGroupVisibility, debounce, handleChange, resetValidation } from "./functions";

var postcodeRegex = new RegExp("^(([A-Z]{1,2}[0-9]{1,2}[A-Z]{0,1})\\s{0,1}([0-9][A-Z]{2,2})|(GIR)\\s{0,1}(0AA))$", "gi");

/**
 * 
 * @param {string} postcode postcode
 * @param {function} callback callback(postcode, addresses)
 */
function doPostcodeSearch(postcode, callback) {
    var postcodeRequest = $.ajax({
        url: '/postcode',
        method: 'POST',
        data: { postcode:  postcode.toString().toUpperCase().replace(' ', '') },
    });
    
    postcodeRequest.done(function(addresses){
        window.postcodeSearches = window.postcodeSearches || {};
        window.postcodeSearches[postcode] = addresses; 
        callback(postcode, addresses);
    });
}

/**
 * 
 * @param {string} postcode postcode
 * @param {array} addresses addresses
 */
function buildOptionsStringFromAddresses(postcode, addresses) {
    if (addresses == null) {
        addresses = [];
    }
    return '<option value="0">Please select your address</option>' + addresses.map((val, index) => {
        return '<option value="' + postcode + '_' + index + '">' + val.full + '</option>' + EOL;
    }).join('');
}

/**
 * 
 * @param {object} address address
 * @param {string} suffix address suffix
 */
function fillAddressFields(address, suffix) {
    $('[name=house' + suffix + ']').val(address.house || '').change();
    $('[name=address1' + suffix + ']').val(address.address1 || '').change();
    $('[name=address2' + suffix + ']').val(address.address2 || '').change();
    $('[name=town' + suffix + ']').val(address.town || '').change();
    $('[name=county' + suffix + ']').val(address.county || '').change();
    $('[name=postcode' + suffix +']').val(address.postcode.toUpperCase().replace(' ', '') || '').change();

    // Build the rollup
    var rollupGroup = $('[data-form-group-name=address_rollup' + suffix + ']');
    if (rollupGroup.length === 1) {
        setFormGroupVisibility(['address_select' + suffix, 'house' + suffix, 'address1' + suffix, 'address2' + suffix, 'town' + suffix, 'county' + suffix, 'postcode' + suffix], false);
        rollupGroup.find('.address-rollup-address p').html(address.full);
        setFormGroupVisibility(['address_rollup' + suffix], true);
    } else {
        setFormGroupVisibility(['address_select' + suffix], false);
        setFormGroupVisibility(['house' + suffix, 'address1' + suffix, 'address2' + suffix, 'town' + suffix, 'county' + suffix, 'postcode' + suffix], true);
    }
}

// Postcode change handler
$(document).on('keyup', '[name=postcode]', function(event){
    window.postCodeSearchDisabled = window.postCodeSearchDisabled || false; 
    var target = $(this);
    var postcode = this.value.replace(' ',  '').toUpperCase();
    if (postcodeRegex.test(postcode) && !window.postCodeSearchDisabled) {
        window.handleCurrentPostcodeSearch(postcode);
    }
});

$(document).on('click', '#findAddress', function(event){
    var postcode = $('[name=postcode]').val();
    window.postCodeSearchDisabled = window.postCodeSearchDisabled || false; 
    var postcode = postcode.replace(' ',  '').toUpperCase();
    if (postcodeRegex.test(postcode) && !window.postCodeSearchDisabled) {
        window.handleCurrentPostcodeSearch(postcode);
    }
});

// Address select change handler
handleChange('[name=address_select]', (event, value, target) => {
    // Get the address object from the searches array
    if (value != 0) {
        var split = value.split('_');
        var postcode = split[0];
        var index = split[1];
        var address = window.postcodeSearches[postcode][index];
        // Fix county issue
        if (isEmpty(address.county) && !isEmpty(address.town)) {
            address.county = address.town;
        }
        fillAddressFields(address, target.is('[name=address_select]') ? '' : '_2');
    }
});

// Address replace button
$(document).on('click', '.address-rollup-replace', function(event){
    var formGroup = $(this).closest('.form-group');
    var suffix = formGroup.is('[data-form-group-name=address_rollup]') ? '' : '_2';
    // Hide this form group
    setFormGroupVisibility(['address_rollup' + suffix], false);
    // Clear the postcode
    $('[name=postcode' + suffix + ']').val('');
    resetValidation('postcode' + suffix);
    resetValidation('address_select' + suffix);
    // Clear any address data in the fields
    $('[name=house' + suffix + '], [name=address1' + suffix + '], [name=address2' + suffix + '], [name=town' + suffix + '], [name=county' + suffix + ']').val('');
    // Show the postcode
    setFormGroupVisibility(['postcode' + suffix], true);
});

// Address edit button
$(document).on('click', '.address-rollup-edit', function(event){
    var formGroup = $(this).closest('.form-group');
    var suffix = formGroup.is('[data-form-group-name=address_rollup]') ? '' : '_2';
    // Hide this form group
    setFormGroupVisibility(['address_rollup' + suffix], false);
    setFormGroupVisibility([
        'postcode' + suffix,
        'house' + suffix,
        'address1' + suffix,
        'address2' + suffix,
        'town' + suffix,
        'county' + suffix,
    ], true);
});

$(document).on('click', '.enter-address-manually', function(event){
    // Show all of the address fields and disable postcode searching
    window.postCodeSearchDisabled = true;
    var formGroup = $(this).closest('.form-group');
    var suffix = formGroup.is('[data-form-group-name=postcode]') ? '' : '_2';
    setFormGroupVisibility([
        'postcode' + suffix,
        'house' + suffix,
        'address1' + suffix,
        'address2' + suffix,
        'town' + suffix,
        'county' + suffix,
    ], true);
    setFormGroupVisibility(['address_rollup' + suffix, 'address_select' + suffix], false);
});

window.handleCurrentPostcodeSearch = debounce((postcode) => {
    var element = $('[name=postcode]');
    var addressSelect = $('[name=address_select]');
    doPostcodeSearch(postcode, (postcode, addresses) => {
        var options = buildOptionsStringFromAddresses(postcode, addresses);
        addressSelect.find('option').remove();
        addressSelect.append($(options));
        setFormGroupVisibility('address_select', true);
    });
}, 250, false);